export const INVALID_EMAIL_ERROR_CODE = 'auth/invalid-email';
export const USER_NOT_FOUND_ERROR_CODE = 'auth/user-not-found';
//eslint-disable-next-line
export const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const MAX_LOGIN_ATTEMPTS_ALLOWED = 3
export const MIN_RECAPTCHA_SCORE = 0.5